"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/ConversationScreen/StoreConversationBox.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');
var _mapChatBoxState = require('shared/selectors/mapChatBoxState');

var _ConversationBox = require('web/components/Conversation/ConversationBox'); var _ConversationBox2 = _interopRequireDefault(_ConversationBox);
var _hooks = require('web/services/hooks');
var _chat = require('shared/enum/chat');
var _blobject = require('shared/selectors/blobject');
var _translation = require('shared/selectors/translation');
var _translation3 = require('shared/hooks/translation');
var _markReadOnOpen = require('./markReadOnOpen');















/* Was connect(mapChatBoxState)(ConversationBox): memo keeps connect's
 * shallow-equal own-props bail-out, the chat state is compared shallowly as
 * connect compared mapState's result, and it is merged over the own props.
 * The one prop connect added that is not passed on is `dispatch`, which
 * ConversationBox never read. */
const StoreConversationBox = (props) => {
  const { conversationKey, blobjectKey } = props
  const anchorSeenTime = _markReadOnOpen.useMarkReadOnOpen.call(void 0, blobjectKey, conversationKey)
  const chatBoxState = _hooks.useAppSelector.call(void 0, 
    state => _mapChatBoxState.selectChatBoxState.call(void 0, state, { ...props, anchorSeenTime }),
    _reactredux.shallowEqual,
  )

  // Lane E: fetch the chat's translation state on open (and on each new
  // patient message); rows read two primitives from it.
  const isPatientChat = _hooks.useAppSelector.call(void 0, state => {
    const type = _blobject.selectBlobjectWrappedType.call(void 0, state, blobjectKey)
    return type === _chat.CHAT_TYPE.REGULAR_PATIENT || type === _chat.CHAT_TYPE.SECURE_PATIENT
  })
  _translation3.useConversationTranslationSync.call(void 0, conversationKey, isPatientChat)
  const showTranslations = _hooks.useAppSelector.call(void 0, state => _translation.selectShowTranslations.call(void 0, state, conversationKey))
  const pillMessageKey = _hooks.useAppSelector.call(void 0, state => _translation.selectVisiblePillMessageKey.call(void 0, state, conversationKey))

  // SAFETY: an empty chat (nothing loaded yet) carries only messageBatches,
  // so the other chat fields are undefined until the first batch arrives, as
  // they were under connect; the screen passes every handler.
  const boxProps = { ...props, ...chatBoxState, showTranslations, pillMessageKey } 

  return _react2.default.createElement(_ConversationBox2.default, { ...boxProps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
}

exports. default = _react.memo.call(void 0, StoreConversationBox)
